<template>
  <v-card elevation="0">
    <v-card-title class="headline">Delivery Zones</v-card-title>
    <v-card-text>
      <mapArea
        @regionEmitted="addRegion"
        :drawingControlStatus="drawingControlStatus"
        :regions="regions"
        :centerLocation="vg_locationCoordinates"
        :cancelHandler="cancelHandler"
        @deleteZoneEmit="deleteRegion"
        @editRegion="emitEditZone"
      />
      <v-data-table
        class="mt-10"
        :headers="headers"
        :items="zones"
        hide-default-footer
        :items-per-page="itemsPerPage"
      >
        <template v-slot:[`item.colour`]="{ item }">
          <v-btn depressed :color="item.colour" fab small dark> </v-btn>
        </template>
        <!-- <template v-slot:item.name="{ item }">
          <v-text-field
            v-model="form.name"
            dense
            hide-details
            placeholder="Input Text"
            v-if="!item.saved"
          />
          <p v-else>{{ item.name }}</p>
        </template> -->
        <template v-slot:[`item.delivery_fee`]="{ item }">
          <v-text-field
            v-model="form.fee"
            dense
            hide-details
            type="number"
            placeholder="Input Amount"
            v-if="!item.saved"
          />
          <p v-else>{{ item.delivery_fee }}</p>
        </template>
        <template v-slot:[`item.min_total_for_delivery`]="{ item }">
          <v-text-field
            v-model="form.minOrder"
            hide-details
            dense
            type="number"
            placeholder="Input Amount"
            v-if="!item.saved"
          />
          <p v-else>{{ item.min_total_for_delivery }}</p>
        </template>
        <template v-slot:[`item.free_delivery_total`]="{ item }">
          <v-text-field
            v-model="form.freeDeliveryMin"
            dense
            hide-details
            type="number"
            placeholder="Input Amount"
            v-if="!item.saved"
          />
          <p v-else>{{ item.free_delivery_total }}</p>
        </template>
        <!-- <template v-slot:item.type="{ item }">
          <div class="grey--text text--darken-3 caption" v-if="!item.saved">
            Not Assigned
            <v-btn small disabled>Edit</v-btn>
          </div>
          <p v-else>none</p>
        </template> -->
        <template v-slot:[`item.edit`]="{ item }">
          <div v-if="!item.saved">
            <v-btn depressed x-small fab @click="saving(item)" class="blue">
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              x-small
              @click="cancel()"
              v-if="!item.statue"
              fab
              class="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-btn
            fab
            x-small
			      depressed
            :disabled="!isItemEditable"
            @click="editingZone(item)"
            v-else
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import mapArea from './mapArea'
import { LocationAPI } from '@/clients/locations/locations.api'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    mapArea
  },
  data() {
    return {
      itemsPerPage: 500,
      headers: [
        { text: 'Zone', value: 'colour', sortable: false },
        { text: 'Delivery Fee', value: 'delivery_fee', sortable: false },
        {
          text: 'Order Minimum',
          value: 'min_total_for_delivery',
          sortable: false
        },
        {
          text: 'Free Delivery Minimum',
          value: 'free_delivery_total',
          sortable: false
        },
        { text: 'Edit', value: 'edit', sortable: false }
      ],
      regions: [],
      zones: [],
      form: {
        name: '',
        fee: null,
        minOrder: null,
        freeDeliveryMin: null
      },
      drawingControlStatus: true,
      colours: [
        '#000075',
        '#e6194B',
        '#3cb44b',
        '#4363d8',
        '#f58231',
        '#46f0f0',
        '#f032e6',
        '#008080',
        '#e6beff',
        '#9A6324',
        '#fffac8',
        '#800000',
        '#aaffc3',
        '#a9a9a9'
      ],
      colourIndex: 0,
      cancelHandler: true,
      editMode: false,
      isItemEditable: true,
      editData: []
    }
  },
  async mounted() {
    // if (this.vg_zonesReload) {
    //   this.vm_setZonesReload(false)
    //   this.$router.go()
    // }
    await this.fetchZones()
  },
  methods: {
    ...mapMutations({
      vm_setZonesReload: 'locations/SET_ZONES_RELOAD'
    }),
    getColours() {
      this.colourIndex = (this.colourIndex + 1) % this.colours.length
      return this.colours[this.colourIndex]
    },
    addRegion(data) {
      this.isItemEditable = false
      this.drawingControlStatus = false
      this.zones.unshift({
        saved: false,
        delivery_polygon: [...data.coordinates]
      })
    },
    emitEditZone(data, index) {
      this.editData = data
    },
    editingZone(item) {
      this.editMode = true
      this.isItemEditable = false
      this.zones.forEach((zone, index) => {
        if (zone.id === item.id) {
          this.form.fee = zone.delivery_fee
          this.form.minOrder = zone.min_total_for_delivery
          this.form.freeDeliveryMin = zone.free_delivery_total
          this.editData = zone.delivery_polygon
          this.zones[index].isEditable = true
          this.zones[index].saved = false
        }
      })
      this.regions = [...this.zones]
    },
    cancel() {
      if (this.editMode) {
        this.zones.forEach((zone, index) => {
          this.zones[index].isEditable = false
          this.zones[index].saved = true
          this.regions[index].isEditable = false
          this.regions[index].saved = true
        })
        this.editMode = false
        this.form = {}
      } else {
        this.zones.shift()
      }
      this.editData = []
      this.isItemEditable = true
      this.cancelHandler = !this.cancelHandler
      this.drawingControlStatus = true
    },
    saving(item) {
      if (this.editMode) {
        this.saveEdited(item)
      } else {
        this.saveNew()
      }
    },
    async saveEdited(item) {
      let data = {
        delivery_fee: this.form.fee,
        min_total_for_delivery: this.form.minOrder,
        free_delivery_total: this.form.freeDeliveryMin,
        delivery_polygon: this.editData
      }
      this.spinner(true)
      try {
        await LocationAPI.editRegion(item.id, data)
        this.spinner(false)
        await this.fetchZones()
      } catch (err) {
        this.spinner(false)
        console.log(err)
      }
    },
    async saveNew() {
      let zone = {
        location_id: this.$route.params.id,
        delivery_fee: this.form.fee,
        min_total_for_delivery: this.form.minOrder,
        free_delivery_total: this.form.freeDeliveryMin,
        delivery_polygon: this.editData.length !== 0 ? this.editData : this.zones[0].delivery_polygon
      }
      this.spinner(true)
      try {
        await LocationAPI.addingDeliveryZone(zone)
        this.spinner(false)
        await this.fetchZones()
      } catch (err) {
        this.spinner(false)
        this.$swal('Failed!', err.response.data.payload[0], 'error')
      }
      this.form = {}
      this.drawingControlStatus = true
    },
    async deleteRegion(zoneId) {
      document.activeElement.blur()
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You want to delete this zone`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then(async function(result) {
        if (result.value) {
          self.spinner(true)
          let res = await await LocationAPI.deleteRegion(zoneId)
          await self.fetchZones()
          self.spinner(false)
          if (res.status === 200) {
            self.$swal('Deleted!', 'successfully deleted.', 'success')
          } else {
            self.$swal('Failed!', 'Please try again later.', 'error')
            this.spinner(false)
          }
        }
      })
    },
    async fetchZones() {
      this.editMode = false
      this.isItemEditable = true
      this.editData = []
      this.form = {}
      this.spinner(true)
      try {
        const {
          data: { payload }
        } = await LocationAPI.fetchRegions(this.$route.params.id)
        this.colourIndex = 0
        payload.forEach(region => {
          region.saved = true
          region.colour = this.getColours()
          region.isEditable = false
        })
        this.zones = [...payload]
        this.regions = [...payload]
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
        if (this.zones.length !== 0) {
          this.zones = []
          this.regions = []
        }
        console.log(err)
      }
    }
  },
  computed: {
    ...mapGetters({
      vg_locationCoordinates: 'locations/selectedLocationCoordinates',
      vg_zonesReload: 'locations/enableZonesReload'
    })
  }
}
</script>
